import { render, staticRenderFns } from "./ValidateButton.vue?vue&type=template&id=1d4bd804"
import script from "./ValidateButton.vue?vue&type=script&lang=js"
export * from "./ValidateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports